<template>
  <div class="upload-box">
    <input
      class="file"
      type="file"
      ref="inputer"
      accept="image/png,image/jpeg,image/jpg,image/gif"
      @change="handleUploadImg"
    />
    <img v-if="img" class="upload-img" :src="img" alt="upload img" />
    <template v-else>
      <img src="./images/icon-upload-min.svg" alt="upload image" />
      <p class="upload-desc" role="upload desc1">{{ i18n.t('mbs-edit-upload1') }}</p>
      <p class="upload-desc" role="upload desc2">{{ i18n.t('mbs-edit-upload2') }}</p>
    </template>
  </div>
</template>

<script>
  import i18n from '@/i18n';

  export default {
    name: 'Upload',

    props: {
      uploadImgs: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        i18n,
        img: this.uploadImgs || '',
        uploadFile: [],
      };
    },

    methods: {
      handleUploadImg() {
        const inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.uploadFile = inputDOM.files;
        this.img = window.URL.createObjectURL(this.uploadFile[0]);
        // 由后端限制
        // eslint-disable-next-line no-plusplus
        // for (let i = 0; i < this.uploadFile.length; i++) {
        //   const size = Math.floor(this.uploadFile[i].size / 1024);
        //   if (size > 10 * 1024) {
        //     // console.error('请选择5M以内的图片!');
        //     this.$refs.inputer = null
        //     return false;
        //   }
        // }
        this.$emit('uploadFile', this.uploadFile);
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import './index.scss';
</style>
